import { IBillingState, TAddCardPayload, TBillingAddressPayload } from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    addCardThunk, getBillingDetailsThunk, saveBillingAddressThunk, updateCardThunk ,initSubscritionThunk
} from './thunks'
import { ServerError } from '../../models/errors'

const initialState: IBillingState = {
    card: {
        cardName: '',
        cardNumber: '',
        expiryMonth: '',
        expiryYear: '',
        cvc: '',
      },
    billingAddress:{
        firstName: '',
        lastName: '',
        address: '',
        state: '',
        city: '',
        country:'',
        zip:''
    },
    planDetails:{
        usercount:0,
        socialcount:0,
        price:'',
        status:'',
        from_date:'',
        to_date:'',
        remainingdays:0
    },
    inProgress: false,
    error: null,
}

const billingSlice = createSlice({
    name: 'billing',
    initialState,
    reducers: {
        resetPaymentErrorAction: (state) => {
            state.error = null
        },
        addCardAction: (state, action: PayloadAction<TAddCardPayload>) => {
            state.card = action.payload
        },
        resetBillingStateAction: () => initialState,
        setCardFormatAction: (state, action: PayloadAction<TAddCardPayload>) => {
            state.card = action.payload
        },
        saveBillingAddressAction: (state,action:PayloadAction<TBillingAddressPayload>)=>{
            state.billingAddress = action.payload;
        },
        updateCardThunkAction: (state,action: PayloadAction<TAddCardPayload>)=>{
            state.card = action.payload
        }
    },
    extraReducers: (builder) => {
        // add card
        builder.addCase(addCardThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(addCardThunk.fulfilled, (state, action) => {
            const {cardNumber,expiryMonth,expiryYear,cardName,country} =  action.payload.data
            state.card = {cardName:cardName,cardNumber:`XXXX XXXX XXXX ${cardNumber}`,expiryMonth,expiryYear,cvc:'',hasTax:country && country === 'AU' ?true:false};
            state.inProgress = false
            state.error = null
        })
        builder.addCase(addCardThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })
        // update card
        builder.addCase(updateCardThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(updateCardThunk.fulfilled, (state, action) => {
            state.inProgress = false
            state.error = null
        })
        builder.addCase(updateCardThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })
        //getBillingDetails
        builder.addCase(getBillingDetailsThunk.pending,(state,action)=>{
            state.error = null
        })
        builder.addCase(getBillingDetailsThunk.fulfilled,(state,action)=>{
            state.inProgress = false;
            state.error = null;
            state.billingAddress = action.payload.billinfo;
            const {cardNumber, country} = action.payload.cardinfo;
            state.card = {...action.payload.cardinfo,cardNumber:`XXXX XXXX XXXX ${cardNumber}`,cvc:'',hasTax:country && country === 'AU' ?true:false};
            state.planDetails = action.payload.planinfo;
        })
        //saving billing address
        builder.addCase(saveBillingAddressThunk.pending,(state,action)=>{
            state.inProgress = true;
            state.error = null
        })

        builder.addCase(saveBillingAddressThunk.fulfilled,(state,action)=>{
            state.inProgress =false
            state.error = null
        })

        builder.addCase(saveBillingAddressThunk.rejected,(state,action)=>{
            state.inProgress =false
            state.error = action.payload as ServerError
        })

        //init Subscription 
        builder.addCase(initSubscritionThunk.pending,(state,action)=>{
            state.inProgress =true
            state.error = null
        })
        builder.addCase(initSubscritionThunk.fulfilled,(state,action)=>{
            state.inProgress =false
            state.error = null
        })
        builder.addCase(initSubscritionThunk.rejected,(state,action)=>{
            state.inProgress =false
            state.error = action.payload as ServerError
        })
    
    }
})

export const {
    resetPaymentErrorAction,
    addCardAction,
    resetBillingStateAction,
    setCardFormatAction,
    saveBillingAddressAction,
    updateCardThunkAction
} = billingSlice.actions
export default billingSlice.reducer
